import ChartActividades from 'pages/Charts/ChartActividades';
import React from 'react'

import {
    Col,
    Row,
    Card,
    CardBody,
  } from "reactstrap";


const GraficasDash = () => {
  return (
<Row>
          <Col lg="6">
                    <Card>
                        <CardBody>

                            <h4 className="card-title mb-4">Cantidad de Socios x actividad</h4>


                            {/* <Row className="text-center mt-4">
                                <Col sm="6">
                                    <h5 className="mb-0 font-size-20">6,95,412</h5>
                                    <p className="text-muted">Activated</p>
                                </Col>
                                <Col sm="6">
                                    <h5 className="mb-0 font-size-20">1,63,542</h5>
                                    <p className="text-muted">Pending</p>
                                </Col>
                            </Row> */}



                            <div dir="ltr">
                               <ChartActividades/>
                            </div>

                        </CardBody>
                    </Card>
                </Col>
</Row>
  )
}

export default GraficasDash